// #region Imports
//Components    
import { defineComponent, defineAsyncComponent } from "vue";
// #endregion
// #region Core
export default defineComponent({
    name: 'g-datetime-edit',
    components: {
        DxDateBox: defineAsyncComponent(async () => {
            return (await import(/* webpackChunkName: "dxCommon" */ /* webpackMode: "lazy" */ 'devextreme-vue/date-box')).DxDateBox;
        }),
    },
    mixins: [appHost.mixins.form],
    props: {
        inputAttr: {
            type: Object,
            required: false,
            default: null,
        },
        showClearButton: {
            type: Boolean,
            required: false,
            default: false
        },
    },
    computed: {
        inputAttrInternal() {
            return this.inputAttr;
        },
    },
    methods: {
        onEnterKey(event) {
            this.$emit('EnterKey', event);
        },
    }
});
// #endregion
